module.exports = __webpack_public_path__ + "media/images/demo/vertical-dark-3102e4d34ede8e380f986e34ca752c1e.jpg";